<fuse-widget class="widget p-0 h-100-p" fxLayout="column">

    <!-- Front -->
    <div class="fuse-widget-front mat-white-bg mat-elevation-z2" fxLayout="column" fxLayoutAlign="stretch stretch"
        [ngStyle]="widgetStyle">

        <div class="px-16 py-8 border-bottom widget-header title-bar" fxLayout="row"
            fxLayoutAlign="space-between center" set-color [backgroundColor]="titleBackgroundColor">
            <div fxLayout="row" fxLayoutAlign="start center" set-color [backgroundColor]="titleBackgroundColor">
                <div id="{{'txtWidgetTitle' + secondaryTitle}}" class="h3 title pr-4">{{title}}</div>
                <div *ngIf="secondaryTitle" fxLayout="row" fxLayoutAlign="start center">
                    <div class="h3 pr-4">-</div>
                    <div id="{{'txtWidgetSubtitle' + secondaryTitle}}" class="h3 secondary" *ngIf="secondaryTitle">
                        {{secondaryTitle}}</div>
                </div>
            </div>
            <div class="actions" fxLayout="row" fxLayoutAlign="start center">
                
                <mat-divider *ngIf="deadlineDaysLeft<=3" class='style-fix' [vertical]="true"></mat-divider>
                <div *ngIf="deadlineDaysLeft<=3" id="DeadlineDue" mat-icon-button class="py-8"
                    [aria-label]="this.deadlineDaysLeftText" [matTooltip]="this.deadlineDaysLeftText">
                    <mat-icon set-color [backgroundColor]="titleBackgroundColor" class="my-8">alarm_on</mat-icon>
                </div>

                <mat-divider *ngIf="(markers>0)" class='style-fix' [vertical]="true"></mat-divider>

                <div *ngIf="markers>0" class="markers" aria-label="Has Markers" matTooltip="Markers" set-color
                    [backgroundColor]="titleBackgroundColor">
                    <mat-icon set-color [backgroundColor]="titleBackgroundColor">room</mat-icon>
                    {{markers}}
                </div>

                <mat-divider *ngIf="restricted" class='style-fix' [vertical]="true"></mat-divider>

                <div *ngIf="restricted" id="{{'restricted' + secondaryTitle}}" mat-icon-button class="py-8"
                    aria-label="restricted" matTooltip="Subject has restricted access">
                    <mat-icon set-color [backgroundColor]="titleBackgroundColor" class="my-8">lock</mat-icon>
                </div>

                <mat-divider *ngIf="allowEdit && ((markers>0) || restricted)" class='style-fix' [vertical]="true">
                </mat-divider>

                <button *ngIf="allowEdit" id="{{'btnWidgetCardEdit' + secondaryTitle}}" #editcardbutton mat-icon-button
                    class="mat-icon-button" aria-label="edit" (click)="editcardbutton._elementRef.nativeElement.blur();edit();" matTooltip="Edit">
                    <mat-icon set-color [backgroundColor]="titleBackgroundColor">edit</mat-icon>
                </button>
            </div>
        </div>

        <gridster [options]="options" class="mat-drawer-container bg-white pt-16 gridster" style="background-color: white;">
            <gridster-item [item]="item.config" *ngFor="let item of _widgets; let i=index" class="no-shadow" [tabindex]="i">
                <div class="no-padding">
                    <ndc-dynamic [ndcDynamicComponent]="item.widget" [ndcDynamicInputs]="item.metadata"></ndc-dynamic>
                </div>
            </gridster-item>
        </gridster>

    </div>
    <!-- / Front -->

</fuse-widget>